import React from 'react'
import BaseRichtext from '../common/BaseRichtext'
import { ImagesSideBySideType } from '../../types/mainModulTypes'
import { API } from '../../constants/constants'
import BaseHeadline from '../common/BaseHeadline'
import BaseSubheadline from '../common/BaseSubheadline'

export default function ImagesSideBySide(props: ImagesSideBySideType) {

    const getAlignment = (alignment?: string): string => {
        if (alignment?.includes("AlignmentVertical")) return "aspect-[3/4]"
        if (alignment?.includes("AlignmentSquare")) return "aspect-square"
        if (alignment?.includes("AlignmentHorizontal")) return "aspect-[4/3]"
        return ""
    }


    return (
        <div className="max-w-content mx-auto px-4 lg:px-0 flex flex-col justify-center text-center">
            <BaseHeadline headlineType={3} label={props.imagesSideBySideHeading} classProps="break-all sm:break-normal" />
            <BaseSubheadline label={props.imagesSideBySideSubheading} classProps="" />

            <div className='flex flex-col sm:flex-row items-start justify-center gap-8 pt-6'>
                <div className='w-full sm:w-1/2 flex flex-col justify-center'>
                    <img
                        src={API + props.imagesSideBySideLeft?.url}
                        alt={props.imagesSideBySideLeft?.description || props.imagesSideBySideLeft?.name}
                        className={`w-full ${getAlignment(props.imageLeftAlignment)} object-cover rounded-default`}
                    />
                    {props.imagesSideBySideLeftText &&
                        <BaseRichtext
                            content={props.imagesSideBySideLeftText}
                            classProps='text-center pt-1'
                        />
                    }
                </div>
                <div className='w-full sm:w-1/2 flex flex-col justify-center'>
                    <img
                        src={API + props.imagesSideBySideRight?.url}
                        alt={props.imagesSideBySideRight?.description || props.imagesSideBySideRight?.name}
                        className={`w-full ${getAlignment(props.imageRightAlignment)} object-cover rounded-default`}
                    />
                    {props.imagesSideBySideRightText &&
                        <BaseRichtext
                            content={props.imagesSideBySideRightText}
                            classProps='text-center pt-1'
                        />
                    }
                </div>
            </div>

        </div>
    )
}
